import React from 'react';
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import IOption from "../../../types/option";
import Search from "../../common/Search";
import PageList from "./PageList";
import { pageAPI } from "../../../api/page";
import { isEmail, normalize } from "../../../utils/convert";
import { TPageResponse, wikiAPI } from "../../../api/wp";

const TracingSearch = () => {
    const options = useAppSelector(state => state.common.options)
    const userOptions = useAppSelector(state => state.user.options)
    const authUser = useAppSelector(state => state.auth.authUser)
    const [checkRedirect, { data: redirect, isLoading: isRedirectLoading, isSuccess: isRedirectSuccess }] = wikiAPI.useCheckRedirectMutation()
    const [addPage, { }] = pageAPI.useAddMutation()

    const chooseHandler = async (option: IOption) => {
        if (!userOptions) return;

        let toAddRedirect = false
        const isTalkPage = option.title.startsWith('Talk:')

        let { data: pagesData } = await checkRedirect({
            titles: [option.title],
            withRedirect: true
        })
        if (!pagesData || !pagesData.page) return;
        if (!authUser) return;

        let pageData: TPageResponse | undefined = pagesData.page
        if (!pageData) return;

        if (pageData.redirectedFrom) {
            const message = `Do you want to add the ${pageData.title} page instead of ${pageData.redirectedFrom} (which is just a redirect)`
            if (!window.confirm(message)) {
                let data = await checkRedirect({
                    titles: [pageData.redirectedFrom],
                    withRedirect: false
                })
                pagesData = data?.data
                pageData = pagesData?.page
                if (!pageData) return;
                toAddRedirect = true
            }
        }

        const email = (options.tracingEmail && isEmail(options.tracingEmail))
            ? options.tracingEmail
            : authUser.email

        const skipInitialMessage = !!(userOptions.skipInitialMessage)

        await addPage({
            id: pageData.id,
            title: pageData.title,
            url: pageData.url ?? '',
            email: email,
            skip: skipInitialMessage,
            revision: pageData.lastRevisionId ?? 0,
            status: toAddRedirect ? 1 : 0
        })

        if (isTalkPage || !(userOptions.addTalkPage)) return;

        const talkPageTitle = `Talk:${pageData.title}`
        let { data: talkPageData } = await checkRedirect({
            titles: [talkPageTitle, talkPageTitle],
            withRedirect: true
        })

        if (!talkPageData?.page) return;

        await addPage({
            id: talkPageData.page.id,
            title: talkPageData.page.title,
            url: talkPageData.page.url ?? '',
            email: email,
            skip: skipInitialMessage,
            revision: talkPageData.page.lastRevisionId ?? 0,
            status: toAddRedirect ? 1 : 0
        })
    }

    return (
        <Search onChoose={chooseHandler} chooseButton={true} />
    );
};

export default TracingSearch;